/**
 * @license
 * Copyright Tyler Technologies, Inc. 
 * License: Apache-2.0
 */
import { defineCustomElement } from '@tylertech/forge-core';
import { BackdropComponent } from './backdrop';
export * from './backdrop-constants';
export * from './backdrop';
export function defineBackdropComponent() {
    defineCustomElement(BackdropComponent);
}
